module.exports = "/lucky-balls/img/regular_game/check_infoBar/check_002.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/check_infoBar/check_002.png
// module id = 1126
// module chunks = 0